<app-settings-card heading="Rechnungsinformationen" (save)="saveSettings()" [disabled]="disabled">
  <form>
    <app-invoice-settings-form
      class="block mt-6"
      [invoiceSettingsForm]="invoiceDetailForm"
      [showInvoiceNumber]="true"
    ></app-invoice-settings-form>
  </form>
</app-settings-card>
